<template>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h3>
        </div>
        <div class="col d-flex justify-content-end align-items-center">
          <router-link to="/add/surah" class="nav-link">
            <base-button
              type="success"
              size="sm"
              class="d-flex justify-content-center align-items-center"
              ><span class="" title="Click to add Chapter">Add Surah</span>
              <span class="ni ni-fat-add" style="font-size: 20px"></span
            ></base-button>
          </router-link>
          <base-button
            type="primary"
            size="sm"
            v-show="total > 15"
            @click="seeAllToggle"
            >{{ seeAll ? "Paginate" : "See All" }}</base-button
          >
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush chapters-table"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        dir="rtl"
        :data="surahs"
      >
        <template slot="columns">
          <th class="text-center">.No</th>
          <th class="text-center">.Chapter No</th>
          <th class="text-center">.Para No</th>
          <th class="text-right">Name</th>
          <th class="text-center">Created At</th>
          <th class="text-center">Actions</th>
          <!-- <th>Completion</th> -->
        </template>

        <template slot-scope="{ row }">
          <th class="text-center">{{ countIndex(row) }}</th>
          <th class="text-center">{{ row.surahNum }}</th>
          <th class="text-center">{{ row.paraNum }}</th>
          <!-- <td class="budget d-flex align-items-center justify-content-end" style="max-width: 200px; text-align: right;">
            <span style="font-size: 24px;">{{row.surahNames | setArabicName}} </span> 
            <span> &#160;&#160;(Arabic)</span>
          </td> -->
          <td class="budget d-flex align-items-center" style="max-width: 400px">
            <span
              style="font-size: 24px"
              lang="ar"
              :class="$store.getters.arabicFontStyle"
              >{{ row.arabicName }}
            </span>
            <span> &#160;&#160;(Arabic)</span>
          </td>
          <td class="budget text-center">
            <span>{{ row.createdAt | moment("MMM DD, YYYY h:m A") }}</span>
          </td>
          <td class="budget text-center">
            <span title="Click to see verses">
              <router-link
                :to="'/surah/' + row.surahNum + '/ayahs'"
                class="nav-link"
                style="display: inline"
              >
                <base-button type="primary" size="sm">
                  Verses <i class="fa fa-eye"></i>
                </base-button>
              </router-link>
            </span>
            <span
              @click="editSurahClick(row)"
              style="margin-left: 10px"
              title="Click to edit chapter"
              class="cursor_pointer"
            >
              <base-button type="default" size="sm">
                Edit <i class="fa fa-edit"></i>
              </base-button>
            </span>
            <span
              @click="deleteSurahClick(row)"
              style="margin-left: 10px"
              title="Click to delete chapter"
              class="cursor_pointer"
            >
              <base-button type="warning" size="sm">
                Delete <i class="fa fa-times"></i>
              </base-button>
            </span>
          </td>
        </template>
      </base-table>
    </div>

    <div
      v-if="!total"
      class="no_record text-gray d-flex justify-content-center py-4"
      style="font-size: 14px"
    >
      No Record Found
    </div>

    <div
      v-if="surahs.length"
      class="card-footer"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <base-pagination
        align="end"
        :total="total"
        :perPage="perPage"
        :pageCount="pageCount"
        :value="page"
        @input="changePage"
      ></base-pagination>
    </div>

    <modal
      :show.sync="updateSurahModal"
      body-classes="p-0"
      modal-classes="modal-dialog-centered modal-lg"
    >
      <card
        type="secondary"
        shadow
        header-classes="bg-white pb-5"
        body-classes="px-lg-4 py-lg-5"
        class="border-0"
      >
        <template>
          <span
            class="close_update_form cursor_pointer"
            @click="updateSurahModal = false"
            >&#10006;</span
          >
          <form @submit.prevent>
            <h6 class="heading-small text-muted mb-4">Surah information</h6>
            <div class="pl-lg-4">
              <div class="row">
                <div class="col-lg-6">
                  <label class="surah__form__label">Surah Number</label>
                  <base-input
                    alternative=""
                    placeholder="Surah Number"
                    input-classes="form-control-alternative"
                    v-model="model.surahNum"
                    type="number"
                    min="1"
                    max="114"
                    @keyup="onKeyUp($event, 'surahNum')"
                    class="mb-0"
                    :class="{ 'input-danger': surahNumErr }"
                  />
                  <span
                    v-show="surahNumErr"
                    class="text-danger"
                    v-text="surahNumMsg"
                  ></span>
                </div>
                <div class="col-lg-6">
                  <label class="surah__form__label">Para Number</label>
                  <base-input
                    alternative=""
                    placeholder="Para Number"
                    input-classes="form-control-alternative"
                    v-model="model.paraNum"
                    type="number"
                    min="1"
                    max="30"
                    @keyup="onKeyUp($event, 'paraNum')"
                    class="mb-0"
                    :class="{ 'input-danger': paraNumErr }"
                  />
                  <span
                    v-show="paraNumErr"
                    class="text-danger"
                    v-text="paraNumMsg"
                  ></span>
                </div>
              </div>
            </div>
            <hr class="my-4" />
            <!-- Address -->
            <h6 class="heading-small text-muted mb-4">
              Surah Name Translations
            </h6>
            <div class="pl-lg-4">
              <!-- <div class="row">
                          <div v-for="(surahName, index) in model.surahNames" class="col-md-12 mb-3" :key="index">
                              <label class="surah__form__label langNameLabel">{{surahName.langName}}</label>
                              <base-input input-classes="form-control-alternative" v-if="surahName.langName != 'Arabština'"
                                          :placeholder="'Enter '+surahName.langName+' Name'" 
                                          v-model="model.surahNames[index].translation" @keyup="onKeyUpTranslationFields($event, index)"
                                          :class="{'has-danger input-danger': model.surahNames[index].langNameErr}" />
                              <base-input input-classes="form-control-alternative py-0 custom_input" v-if="surahName.langName == 'Arabština'"
                                          :placeholder="'Enter '+surahName.langName+' Name'" class="dir__rtl"
                                          v-model="model.surahNames[index].translation" @keyup="onKeyUpTranslationFields($event, index)"
                                          :class="{'has-danger input-danger': model.surahNames[index].langNameErr}" />
                              <span v-show="model.surahNames[index].langNameErr" class="text-danger" 
                                    v-text="model.surahNames[index].langNameMsg"></span>
                          </div>
                      </div> -->
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label class="surah__form__label langNameLabel"
                    >Arabština</label
                  >
                  <textarea
                    class="form-control form-control-alternative custom_input dir__rtl"
                    name="arabicName"
                    :placeholder="'Enter Arabština Name'"
                    style="padding: 5px 10px 4px 10px"
                    rows="1"
                    @keypress.enter.prevent
                    v-model="model.arabicName"
                    @input="model.arabicName = changeIntoArabic($event)"
                    :class="[
                      arabicNameErr && 'input-danger',
                      model.arabicName && $store.getters.arabicFontStyle,
                    ]"
                  />
                  <span
                    v-show="arabicNameErr"
                    class="text-danger"
                    v-text="arabicNameMsg"
                  ></span>
                </div>
                <div class="col-md-12 mb-3">
                  <label class="surah__form__label langNameLabel"
                    >Čeština</label
                  >
                  <base-input
                    input-classes="form-control-alternative"
                    :placeholder="'Enter Čeština Name'"
                    v-model="model.czechName"
                    @keyup="onKeyUp($event, 'czechName')"
                    :class="{ 'has-danger input-danger': czechNameErr }"
                  />
                  <span
                    v-show="czechNameErr"
                    class="text-danger"
                    v-text="czechNameMsg"
                  ></span>
                </div>
                <div class="col-md-12 mb-3">
                  <label class="surah__form__label langNameLabel"
                    >Čeština Transliteration</label
                  >
                  <base-input
                    input-classes="form-control-alternative"
                    :placeholder="'Enter Čeština transliteration Name'"
                    v-model="model.czechTrans"
                    @keyup="onKeyUp($event, 'czechTrans')"
                    :class="{ 'has-danger input-danger': czechTransErr }"
                  />
                  <span
                    v-show="czechTransErr"
                    class="text-danger"
                    v-text="czechTransMsg"
                  ></span>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <base-button
                  type="default"
                  class="my-4"
                  @click.prevent="resetForm"
                  >Reset</base-button
                >
                <base-button
                  type="success"
                  class="my-4"
                  @click.prevent="updateSurahClick"
                  >Update Surah</base-button
                >
              </div>
            </div>
          </form>
        </template>
      </card>
    </modal>
  </div>
</template>
<script>
import moment from "moment";

import * as api from "@/apiList";
export default {
  name: "surahs-table",
  props: {
    type: String,
    surahs: Array,
    title: String,
    page: Number,
    perPage: Number,
    total: Number,
    seeAll: Boolean,
  },
  data() {
    return {
      updateSurahModal: false,
      languages: JSON.parse(localStorage.getItem("languages")),

      model: {
        surahNum: "",
        paraNum: "",
        // surahNames: [],
        arabicName: "",
        czechName: "",
        czechTrans: "",
      },
      surahNumErr: false,
      paraNumErr: false,
      arabicNameErr: false,
      czechNameErr: false,
      czechTransErr: false,
      surahNumMsg: "",
      paraNumMsg: "",
      arabicNameMsg: "",
      czechNameMsg: "",
      czechTransMsg: "",

      surahToUpdateIndex: null,
    };
  },
  methods: {
    async setArabicLangId() {
      this.languages.forEach((elem) => {
        if (elem.name == "Arabština") {
          localStorage.setItem("arabicLangId", JSON.stringify(elem._id));
          return;
        }
      });
    },
    async updateSurahClick() {
      if (this.validateForm()) {
        const id = this.surahs[this.surahToUpdateIndex]._id;
        this.model.id = id;
        const updateRes = await api.updateSurah(this.model);
        if (!updateRes.response) {
          this.updateSurahModal = false;
          this.surahs[this.surahToUpdateIndex] = {
            ...this.surahs[this.surahToUpdateIndex],
            ...this.model,
          };
          this.$toast("Chapter Updated Successfully.", {
            position: "top-right",
            timeout: 5000,
            type: "success",
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            icon: true,
            rtl: false,
          });
        } else {
          this.$toast(`${updateRes.response.data.message}`, {
            position: "top-right",
            timeout: 5000,
            type: "error",
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            icon: true,
            rtl: false,
          });
        }
      }
    },

    editSurahClick(surah) {
      this.model = {};
      this.surahNumErr = false;
      this.paraNumErr = false;

      this.surahToUpdateIndex = this.surahs.indexOf(surah);
      this.model = { ...this.model, ...surah };
      // this.model.surahNames = [];
      // let arabicLangObj = null;
      // let czechHrbekLangObj = null;
      // this.languages.forEach(elem => {
      //     let language = {translation: '', translationId: elem._id, langName: elem.name}
      //     if(elem.name == 'Arabština'){
      //         arabicLangObj = language;
      //     }
      //     else if(elem.name == 'Čeština - Hrbek') {
      //         czechHrbekLangObj = language;
      //     }
      //     else{
      //         this.model.surahNames.push(language)
      //     }
      // })
      // this.model.surahNames.unshift(arabicLangObj);
      // this.model.surahNames.splice(1, 0, czechHrbekLangObj);
      // this.model.surahNames.forEach(el => {
      //   surah.surahNames.forEach(elem => {
      //     if(el.translationId == elem.translationId) {
      //       el.translation = elem.translation;
      //     }
      //   })
      // })
      this.updateSurahModal = true;
    },
    deleteSurahClick(surah) {
      this.$confirm({
        title: "Confirmations!",
        message: `Are you sure to delete this surah? It may contains ayahs which would also be deleted.`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            const data = await api.deleteSurah(surah._id);
            if (!data.response) {
              this.surahs.splice(this.surahs.indexOf(surah), 1);
              this.$toast("Chapter Deleted Successfully with its Verses.", {
                position: "top-right",
                timeout: 5000,
                type: "success",
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                icon: true,
                rtl: false,
              });
            } else {
              this.$toast(`${data.response.data.message}`, {
                position: "top-right",
                timeout: 5000,
                type: "error",
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                icon: true,
                rtl: false,
              });
            }
          }
        },
      });
    },

    resetForm() {
      this.$confirm({
        title: "Confirmations!",
        message: `Are you sure you want to reset the form because this action is not reveratable`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: async (confirm) => {
          if (confirm) {
            this.model = {};
          }
        },
      });
    },
    validateForm() {
      let hasErr = false;
      let instance = this;
      let model_inst = this.model;
      Object.keys(model_inst).forEach((elem) => {
        if (!model_inst[elem] && elem != "paraNum" && elem != "__v" && model_inst[elem].trim() == ' ') {
          instance[elem + "Err"] = true;
          this[elem + "Msg"] = "This field is required.";
          hasErr = true;
        }
      });
      // model_inst.surahNames.forEach(elem => {
      //     if(!elem.translation || elem.translation == '') {
      //         if (elem.langName == 'Arabština') {
      //             elem.langNameErr = true;
      //             elem.langNameMsg = elem.langName + ' name is must.';
      //             hasErr = true;
      //         }
      //         if (elem.langName == 'Čeština - Hrbek') {
      //             elem.langNameErr = true;
      //             elem.langNameMsg = elem.langName + ' name is must';
      //             hasErr = true;
      //         }
      //     }
      // })
      return !hasErr;
    },
    onKeyUp: function (event, inputName) {
      let { surahNum, paraNum } = this.model;
      if (inputName == "surahNum") {
        this.surahNumErr = false;
        if (surahNum < 0) {
          this.model.surahNum = 1;
        }
        if (surahNum > 114) {
          this.model.surahNum = 114;
        }
      }
      if (inputName == "paraNum") {
        this.paraNumErr = false;
        if (paraNum < 0) {
          this.model.paraNum = 1;
        }
        if (paraNum > 30) {
          this.model.paraNum = 30;
        }
      }
    },
    // onKeyUpTranslationFields: function(event, index){
    //     this.model.surahNames[index].langNameErr = false;
    // },

    changeIntoArabic(e) {
      if (e.target.name == "arabicName") {
        this.arabicNameErr = false;
      }
      let val = e.target.value;
      val = val.replace(/`/g, "ذ");
      val = val.replace(/0/g, "۰");
      val = val.replace(/1/g, "۱");
      val = val.replace(/2/g, "۲");
      val = val.replace(/3/g, "۳");
      val = val.replace(/4/g, "٤");
      val = val.replace(/5/g, "۵");
      val = val.replace(/6/g, "٦");
      val = val.replace(/7/g, "۷");
      val = val.replace(/8/g, "۸");
      val = val.replace(/9/g, "۹");
      val = val.replace(/0/g, "۰");
      val = val.replace(/q/g, "ض");
      val = val.replace(/w/g, "ص");
      val = val.replace(/e/g, "ث");
      val = val.replace(/r/g, "ق");
      val = val.replace(/t/g, "ف");
      val = val.replace(/y/g, "غ");
      val = val.replace(/u/g, "ع");
      val = val.replace(/i/g, "ه");
      val = val.replace(/o/g, "خ");
      val = val.replace(/p/g, "ح");
      val = val.replace(/\[/g, "ج");
      val = val.replace(/\]/g, "د");
      val = val.replace(/a/g, "ش");
      val = val.replace(/s/g, "س");
      val = val.replace(/d/g, "ي");
      val = val.replace(/f/g, "ب");
      val = val.replace(/g/g, "ل");
      val = val.replace(/h/g, "ا");
      val = val.replace(/j/g, "ت");
      val = val.replace(/k/g, "ن");
      val = val.replace(/l/g, "م");
      val = val.replace(/\;/g, "ك");
      val = val.replace(/\'/g, "ط");
      val = val.replace(/z/g, "ئ");
      val = val.replace(/x/g, "ء");
      val = val.replace(/c/g, "ؤ");
      val = val.replace(/v/g, "ر");
      val = val.replace(/b/g, "لا");
      val = val.replace(/n/g, "ى");
      val = val.replace(/m/g, "ة");
      val = val.replace(/\,/g, "و");
      val = val.replace(/\./g, "ز");
      val = val.replace(/\//g, "ظ");
      val = val.replace(/~/g, " ّ");
      val = val.replace(/Q/g, "َ");
      val = val.replace(/W/g, "ً");
      val = val.replace(/E/g, "ُ");
      val = val.replace(/R/g, "ٌ");
      val = val.replace(/T/g, "لإ");
      val = val.replace(/Y/g, "إ");
      val = val.replace(/U/g, "‘");
      val = val.replace(/I/g, "÷");
      val = val.replace(/O/g, "×");
      val = val.replace(/P/g, "؛");
      val = val.replace(/A/g, "ِ");
      val = val.replace(/S/g, "ٍ");
      val = val.replace(/G/g, "لأ");
      val = val.replace(/H/g, "أ");
      val = val.replace(/J/g, "ـ");
      val = val.replace(/K/g, "،");
      val = val.replace(/L/g, "/");
      val = val.replace(/Z/g, "~");
      val = val.replace(/X/g, "ْ");
      val = val.replace(/B/g, "لآ");
      val = val.replace(/N/g, "آ");
      val = val.replace(/M/g, "’");
      val = val.replace(/\?/g, "؟");
      e.target.value = val;
      return e.target.value;
    },

    countIndex(item) {
      let index = this.surahs.indexOf(item) + 1;
      let page = this.page - 1;
      if (page > 0) {
        if (index == 10) {
          page = page + 1;
          index = 0;
          return page.toString() + index.toString();
        } else {
          return page.toString() + index.toString();
        }
      } else {
        return index.toString();
      }
    },
    changePage(value) {
      this.$emit("pageChange", value);
    },
    seeAllToggle() {
      this.$emit("seeAllToggle");
    },
  },
  filters: {
    setArabicName: function (names) {
      let arabicLangId = JSON.parse(localStorage.getItem("arabicLangId"));
      let arabicName = null;
      names.forEach((name) => {
        if (name.translationId == arabicLangId) {
          arabicName = name.translation;
        }
      });
      return arabicName;
    },
  },
  computed: {
    pageCount() {
      let pageCount = this.total / this.perPage;
      if (pageCount > 0) {
        return Math.ceil(pageCount);
      } else {
        return 0;
      }
    },
  },
  mounted() {
    this.setArabicLangId();
  },
};
</script>
<style>
.cursor_pointer {
  cursor: pointer;
}
.close_update_form {
  position: absolute;
  top: 10px;
  right: 12px;
  font-size: 12px;
}
.add__user_cross {
  position: absolute;
  right: 0 !important;
  top: -3px;
  border: 1px solid #f7fafc;
  background-color: #f7fafc;
  padding: 10px 15px;
  z-index: 9;
  border-radius: 100px;
  color: purple;
}
span.text-danger {
  font-size: 12px !important;
}
.input-danger {
  border: 1px solid red !important;
  border-radius: 7px;
}
.add__surah__form form {
  background: #f7fafc;
  padding: 10px 20px;
  border-radius: 0.375rem;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15) !important;
}
.surah__form__label {
  color: #525f7f;
  font-size: 0.875rem;
  font-weight: 600;
}
.surah__form__label.langNameLabel + div {
  margin-bottom: 0px;
}

.chapters-table tbody tr:hover {
  outline: 2px solid #e0ffffc4 !important;
  background: #e0ffffc4;
}
</style>
